(function($){
    var sliders = $('.sliders'),
        slidersControls = $('.slick_controls');

    if ( ! sliders.length > 0 ){ return }

    sliders.slick({ 
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        appendArrows: slidersControls,
        prevArrow: '<button type="button" class="slick-prev"><i class="mgi-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="mgi-chevron-right"></i></button>',
        appendDots: $('.story_thumbnails'),
        customPaging : function (slider, i) {
            var thumb = $(slider.$slides[i]).data('thumbnail'),
                title = $(slider.$slides[i]).data('title'),
                preview = $(slider.$slides[i]).data('preview'),
                link = $(slider.$slides[i]).data('link');
            return  '<div class="col-xs-12 col-sm-4">' +
                        '<div class="story">' +
                            '<div class="left">'+
                                ' <div class="circled"> ' +
                                    '<img class="img-circle" src="'+thumb+'" alt="'+title+'" > ' +
                                '</div>' +
                            '</div>'+
                            ' <div class="right excerpt">'+
                                '<p>'+ preview +'</p>'+
                                '<a href="'+link+'" class="outline green bg_green">Read full case study</a>' +
                            '</div>'+
                        '</div>' +
                    '</div>';
        }
    });

    if ( $('.slick-active .quotes').length > 0 ){
        slidersControls.addClass('has_quote');
    }

    sliders.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var nextSlider = $(slick.$slides[nextSlide]);

        if ( $(nextSlider[0]).find('.quotes').length > 0 ){
            slidersControls.removeClass('has_quote');
            slidersControls.addClass('has_quote');
        } else{
            slidersControls.removeClass('has_quote');
        }
    });



})(jQuery);